export enum APP_EXTENSION_MESSAGE {
    SCRAPPED_DATA = "scraped-data",
    LOGOUT = "logout",
    ERROR = "error",
    MANIFEST_VERSION = "manifest-version",
}
